import { Recurrence } from '@tableau/self-service-schedules';
import shallowEqual from 'shallowequal';

import {
  SessionSiteSelectors,
} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { SelfServiceSchedule } from '~src/schedule/serverApi/types/SelfServiceSchedule';

// This feature is ~Cloud Only~ and is turned on with a DB Migration for all Cloud sites by default upon release
// Also, it is not a toggleable site setting
export function isFlowSelfServiceSchedulesEnabled() {
  const state = getAppStore().getState();
  const isSiteSettingEnabled = SessionSiteSelectors.isSelfServiceSchedulesForFlowEnabled(state);

  return isSiteSettingEnabled;
}

export function areRecurrencesIdentical(s1: Recurrence, s2: Recurrence): boolean {
  return shallowEqual(s1, s2, (a: Recurrence, b: Recurrence, indexOrKey: string) => {
    return indexOrKey === 'recurrenceDetails' ? shallowEqual(a, b) : void 0;
  });
}

export function convertRecurrenceToSelfServiceScheduleViewModel(recurrence: Recurrence) {
  return recurrence ? SelfServiceSchedule.fromRecurrence(recurrence, 'Flow') : null;
}
